// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__sSzsh","col":"ProductsDashboard_col__sfaoN","card":"ProductsDashboard_card__XZwb+"};